<template>
  <div class="page-wrapper">
    <!-- ========== PC版 ========== -->
    <div class="pc-version">
      <div
        class="loss-log-container"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <!-- PC 搜索栏 -->
        <div
          class="search-bar"
          style="
            margin-bottom: 20px;
            display: flex;
            gap: 10px;
            align-items: center;
            flex-wrap: wrap;
          "
        >
          <div class="search-collapse-btn" @click="toggleSearch">
            <i
              class="el-icon-arrow-down"
              :class="{ 'el-icon-arrow-up': !searchCollapsed }"
            ></i>
            {{ searchCollapsed ? "展开搜索" : "收起搜索" }}
          </div>
          <div
            :style="{
              display: searchCollapsed ? 'none' : 'flex',
              gap: '10px',
              alignItems: 'center',
            }"
          >
            <el-input
              v-model="searchParams.user_id"
              placeholder="用户ID"
              style="width: 160px"
              clearable
            ></el-input>
            <el-date-picker
              v-model="searchParams.start_at"
              type="date"
              placeholder="开始日期"
              style="width: 160px"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
            <el-date-picker
              v-model="searchParams.end_at"
              type="date"
              placeholder="结束日期"
              style="width: 160px"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </div>
          <div style="display: flex; gap: 10px; margin-left: 10px">
            <el-button type="primary" @click="getList">搜索</el-button>
            <el-button @click="resetSearch">重置</el-button>
            <!-- PC 查看历史按钮 -->
            <el-button
              type="success"
              @click="openHistory"
              :disabled="!searchParams.user_id"
            >
              查看历史
            </el-button>

            <!-- ========== 新增列筛选popover ========== -->
            <el-popover
              placement="bottom"
              title="显示列筛选"
              trigger="click"
              width="220"
            >
              <el-checkbox-group v-model="checkedColumns">
                <el-checkbox
                  v-for="item in columnOptions"
                  :key="item.prop"
                  :label="item.prop"
                  >{{ item.label }}</el-checkbox
                >
              </el-checkbox-group>
              <div style="text-align: right; margin-top: 8px">
                <el-button size="mini" @click="handleCheckAll">全选</el-button>
                <el-button size="mini" @click="handleClearAll">清空</el-button>
              </div>
              <el-button slot="reference" icon="el-icon-s-tools" type="info"
                >列筛选</el-button
              >
            </el-popover>
          </div>
        </div>

        <!-- 表格：亏损金额固定右侧 -->
        <div class="table-wrapper">
          <el-table :data="tableData" border stripe style="width: 100%">
            <!-- 固定左列 新增头像、昵称、用户编号 -->
            <el-table-column
              label="用户ID"
              prop="user_id"
              width="100"
              align="center"
              fixed="left"
              v-if="checkedColumns.includes('user_id')"
            />
            <el-table-column
              label="头像"
              prop="avatar"
              width="80"
              align="center"
              fixed="left"
              v-if="checkedColumns.includes('avatar')"
            >
              <template #default="{ row }">
                <img v-if="row.avatar" :src="row.avatar" class="table-avatar" />
                <span v-else class="avatar-empty">无</span>
              </template>
            </el-table-column>
            <el-table-column
              label="用户昵称"
              prop="nickname"
              width="180"
              align="center"
              fixed="left"
              v-if="checkedColumns.includes('nickname')"
            />
            <el-table-column
              label="用户编号"
              prop="user_no"
              width="180"
              align="center"
              fixed="left"
              v-if="checkedColumns.includes('user_no')"
            />
            <el-table-column
              label="盘账日期"
              prop="date_desc"
              width="160"
              align="center"
              v-if="checkedColumns.includes('date_desc')"
            />

            <el-table-column
              label="期初金额"
              prop="init_amount"
              width="110"
              align="center"
              v-if="checkedColumns.includes('init_amount')"
            >
              <template #default="{ row }">
                <div class="cell-full" @click="openDetail(row, 'init_amount')">
                  {{ row.init_amount }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="未开盒子"
              prop="wk_box_amount"
              width="120"
              align="center"
              v-if="checkedColumns.includes('wk_box_amount')"
            >
              <template #default="{ row }">
                <div
                  class="cell-full"
                  @click="openDetail(row, 'wk_box_amount')"
                >
                  {{ row.wk_box_amount }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="充值金额"
              prop="recharge_amount"
              width="110"
              align="center"
              v-if="checkedColumns.includes('recharge_amount')"
            >
              <template #default="{ row }">
                <div
                  class="cell-full"
                  @click="openDetail(row, 'recharge_amount')"
                >
                  {{ row.recharge_amount }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="赠送金额"
              prop="give_amount"
              width="110"
              align="center"
              v-if="checkedColumns.includes('give_amount')"
            >
              <template #default="{ row }">
                <div class="cell-full" @click="openDetail(row, 'give_amount')">
                  {{ row.give_amount }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="提货金额"
              prop="take_amount"
              width="110"
              align="center"
              v-if="checkedColumns.includes('take_amount')"
            >
              <template #default="{ row }">
                <div class="cell-full" @click="openDetail(row, 'take_amount')">
                  {{ row.take_amount }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="普通赏袋"
              prop="normal_prize_amount"
              width="120"
              align="center"
              v-if="checkedColumns.includes('normal_prize_amount')"
            >
              <template #default="{ row }">
                <div
                  class="cell-full"
                  @click="openDetail(row, 'normal_prize_amount')"
                >
                  {{ row.normal_prize_amount }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="许愿金额"
              prop="wish_amount"
              width="110"
              align="center"
              v-if="checkedColumns.includes('wish_amount')"
            >
              <template #default="{ row }">
                <div class="cell-full" @click="openDetail(row, 'wish_amount')">
                  {{ row.wish_amount }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="卡册金额"
              prop="card_amount"
              width="110"
              align="center"
              v-if="checkedColumns.includes('card_amount')"
            >
              <template #default="{ row }">
                <div class="cell-full" @click="openDetail(row, 'card_amount')">
                  {{ row.card_amount }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="保险箱"
              prop="lock_amount"
              width="110"
              align="center"
              v-if="checkedColumns.includes('lock_amount')"
            >
              <template #default="{ row }">
                <div class="cell-full" @click="openDetail(row, 'lock_amount')">
                  {{ row.lock_amount }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="金币"
              prop="balance"
              width="100"
              align="center"
              v-if="checkedColumns.includes('balance')"
            >
              <template #default="{ row }">
                <div class="cell-full" @click="openDetail(row, 'balance')">
                  {{ row.balance }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="能量"
              prop="energy"
              width="100"
              align="center"
              v-if="checkedColumns.includes('energy')"
            >
              <template #default="{ row }">
                <div class="cell-full" @click="openDetail(row, 'energy')">
                  {{ row.energy }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="钻石"
              prop="point"
              width="100"
              align="center"
              v-if="checkedColumns.includes('point')"
            >
              <template #default="{ row }">
                <div class="cell-full" @click="openDetail(row, 'point')">
                  {{ row.point }}
                </div>
              </template>
            </el-table-column>

            <!-- 新增4个币种列 -->
            <el-table-column
              label="无限币"
              prop="blind_point"
              width="100"
              align="center"
              v-if="checkedColumns.includes('blind_point')"
            >
              <template #default="{ row }">
                <div class="cell-full" @click="openDetail(row, 'blind_point')">
                  {{ row.blind_point }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="擂台币"
              prop="challenge_point"
              width="100"
              align="center"
              v-if="checkedColumns.includes('challenge_point')"
            >
              <template #default="{ row }">
                <div class="cell-full" @click="openDetail(row, 'challenge_point')">
                  {{ row.challenge_point }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="闯关币"
              prop="fight_point"
              width="100"
              align="center"
              v-if="checkedColumns.includes('fight_point')"
            >
              <template #default="{ row }">
                <div class="cell-full" @click="openDetail(row, 'fight_point')">
                  {{ row.fight_point }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="PK币"
              prop="pk_point"
              width="100"
              align="center"
              v-if="checkedColumns.includes('pk_point')"
            >
              <template #default="{ row }">
                <div class="cell-full" @click="openDetail(row, 'pk_point')">
                  {{ row.pk_point }}
                </div>
              </template>
            </el-table-column>

            <!-- 亏损金额 固定右侧 -->
            <el-table-column
              label="亏损金额"
              prop="loss_amount"
              width="120"
              align="center"
              fixed="right"
              v-if="checkedColumns.includes('loss_amount')"
            >
              <template slot-scope="scope">
                <span
                  :style="{
                    color: scope.row.loss_amount >= 0 ? '#67c23a' : '#f56c6c',
                    fontWeight: 600,
                  }"
                >
                  {{ scope.row.loss_amount }}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>
      </div>
    </div>

    <!-- ========== 移动端 ========== -->
    <div class="mobile-version">
      <div
        class="mobile-container"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <div class="mobile-search">
          <div class="mobile-search-collapse" @click="toggleSearch">
            {{ searchCollapsed ? "展开搜索条件 ▼" : "收起搜索条件 ▲" }}
          </div>
          <div
            v-if="!searchCollapsed"
            style="display: flex; flex-direction: column; gap: 8px"
          >
            <el-input
              v-model="searchParams.user_id"
              placeholder="用户ID"
              clearable
              size="medium"
            ></el-input>
            <el-date-picker
              v-model="searchParams.start_at"
              type="date"
              placeholder="开始日期"
              style="width: 100%"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
            <el-date-picker
              v-model="searchParams.end_at"
              type="date"
              placeholder="结束日期"
              style="width: 100%"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </div>
          <div style="display: flex; gap: 8px; margin-top: 10px">
            <el-button
              type="primary"
              plain
              round
              style="flex: 1"
              @click="getList"
              >搜索</el-button
            >
            <el-button plain round style="flex: 1" @click="resetSearch"
              >重置</el-button
            >
            <!-- 移动端 查看历史按钮 -->
            <el-button
              type="success"
              plain
              round
              style="flex: 1"
              @click="openHistory"
              :disabled="!searchParams.user_id"
              >查看历史</el-button
            >
          </div>
        </div>

        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.user_id"
          >
            <div class="card-top">
              <div class="label">用户ID：{{ item.user_id }}</div>
              <div
                class="loss"
                :style="{
                  color: item.loss_amount >= 0 ? '#67c23a' : '#f56c6c',
                }"
              >
                亏损：{{ item.loss_amount }}
              </div>
            </div>
            <!-- 移动端新增头像、昵称、用户编号 -->
            <div class="card-user-info">
              <img
                v-if="item.avatar"
                :src="item.avatar"
                class="mobile-avatar"
              />
              <div class="user-text">
                <div>昵称：{{ item.nickname || "-" }}</div>
                <div>编号：{{ item.user_no || "-" }}</div>
              </div>
            </div>

            <div class="card-body">
              <div><span>盘账日期：</span>{{ item.date_desc }}</div>
              <div @click="openDetail(item, 'init_amount')">
                <span>期初金额：</span>{{ item.init_amount }}
              </div>
              <div @click="openDetail(item, 'recharge_amount')">
                <span>充值金额：</span>{{ item.recharge_amount }}
              </div>
              <div @click="openDetail(item, 'give_amount')">
                <span>赠送金额：</span>{{ item.give_amount }}
              </div>
              <div @click="openDetail(item, 'take_amount')">
                <span>提货金额：</span>{{ item.take_amount }}
              </div>
              <div @click="openDetail(item, 'normal_prize_amount')">
                <span>普通赏袋：</span>{{ item.normal_prize_amount }}
              </div>
              <div @click="openDetail(item, 'wish_amount')">
                <span>许愿金额：</span>{{ item.wish_amount }}
              </div>
              <div @click="openDetail(item, 'card_amount')">
                <span>卡册金额：</span>{{ item.card_amount }}
              </div>
              <div @click="openDetail(item, 'lock_amount')">
                <span>保险箱：</span>{{ item.lock_amount }}
              </div>
              <div @click="openDetail(item, 'wk_box_amount')">
                <span>未开盒子：</span>{{ item.wk_box_amount }}
              </div>
              <div @click="openDetail(item, 'balance')">
                <span>金币：</span>{{ item.balance }}
              </div>
              <div @click="openDetail(item, 'energy')">
                <span>能量：</span>{{ item.energy }}
              </div>
              <div @click="openDetail(item, 'point')">
                <span>钻石：</span>{{ item.point }}
              </div>
              <!-- 移动端新增4个币种 -->
              <div @click="openDetail(item, 'blind_point')">
                <span>无限币：</span>{{ item.blind_point }}
              </div>
              <div @click="openDetail(item, 'challenge_point')">
                <span>擂台币：</span>{{ item.challenge_point }}
              </div>
              <div @click="openDetail(item, 'fight_point')">
                <span>闯关币：</span>{{ item.fight_point }}
              </div>
              <div @click="openDetail(item, 'pk_point')">
                <span>PK币：</span>{{ item.pk_point }}
              </div>
            </div>
          </div>
        </div>

        <div style="margin-top: 15px; text-align: center">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="prev, pager, next, total"
            :total="total"
            pager-count="2"
            small
          />
        </div>
      </div>
    </div>

    <!-- =============== PC 独立弹窗 =============== -->
    <el-dialog
      :title="fieldText + '详情'"
      :visible.sync="pcDetailVisible"
      width="700px"
      append-to-body
      v-loading="detailLoading"
    >
      <div class="pc-detail-content">
        <div><label>用户ID：</label>{{ showRow.user_id }}</div>
        <!-- 详情弹窗补充用户信息 -->
        <div><label>用户编号：</label>{{ showRow.user_no || "-" }}</div>
        <div><label>用户昵称：</label>{{ showRow.nickname || "-" }}</div>
        <div v-if="showRow.avatar">
          <label>头像：</label>
          <img :src="showRow.avatar" class="detail-avatar" />
        </div>
        <div><label>日期：</label>{{ showRow.date_desc }}</div>
        <div>
          <label>当前明细：</label
          ><span style="color: #1890ff; font-weight: bold">{{
            fieldText
          }}</span>
        </div>
        <div>
          <label>明细金额：</label>
          <span
            :style="{ color: showRow[showField] >= 0 ? '#67c23a' : '#f56c6c' }"
          >
            {{ showRow[showField] }}
          </span>
        </div>
        <div style="margin-top: 10px"><label>明细内容：</label></div>
        <div class="detail-list">{{ detailContent || "暂无数据" }}</div>
      </div>
      <div slot="footer" style="text-align: right">
        <el-button @click="pcDetailVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- =============== 移动 独立弹窗 =============== -->
    <el-dialog
      :title="fieldText + '详情'"
      :visible.sync="mobileDetailVisible"
      width="90%"
      append-to-body
      v-loading="detailLoading"
    >
      <div class="mobile-detail-content">
        <div><label>用户ID：</label>{{ showRow.user_id }}</div>
        <div><label>用户编号：</label>{{ showRow.user_no || "-" }}</div>
        <div><label>用户昵称：</label>{{ showRow.nickname || "-" }}</div>
        <div v-if="showRow.avatar">
          <label>头像：</label>
          <img :src="showRow.avatar" class="detail-avatar" />
        </div>
        <div><label>日期：</label>{{ showRow.date_desc }}</div>
        <div>
          <label>当前明细：</label
          ><span style="color: #1890ff; font-weight: bold">{{
            fieldText
          }}</span>
        </div>
        <div>
          <label>明细金额：</label>
          <span
            :style="{ color: showRow[showField] >= 0 ? '#67c23a' : '#f56c6c' }"
          >
            {{ showRow[showField] }}
          </span>
        </div>
        <div style="margin-top: 10px"><label>明细内容：</label></div>
        <div class="detail-list">{{ detailContent || "暂无数据" }}</div>
      </div>
      <div slot="footer" style="text-align: right">
        <el-button @click="mobileDetailVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- =============== 历史亏损弹窗 =============== -->
    <el-dialog
      :title="'用户(' + searchParams.user_id + ')历史亏损记录'"
      :visible.sync="historyVisible"
      width="90%"
      append-to-body
      v-loading="historyLoading"
    >
      <!-- PC 历史表格 - 展示全部字段 -->
      <div class="history-table-wrapper" v-if="isPC">
        <el-table
          :data="historyData"
          border
          stripe
          size="medium"
          v-if="historyData.length > 0"
        >
          <!-- 历史表格左侧新增头像、昵称、用户编号固定列 -->
          <el-table-column
            label="用户ID"
            prop="user_id"
            width="100"
            align="center"
            fixed="left"
          />
          <el-table-column
            label="头像"
            prop="avatar"
            width="80"
            align="center"
            fixed="left"
          >
            <template #default="{ row }">
              <img v-if="row.avatar" :src="row.avatar" class="table-avatar" />
              <span v-else class="avatar-empty">无</span>
            </template>
          </el-table-column>
          <el-table-column
            label="用户昵称"
            prop="nickname"
            width="140"
            align="center"
            fixed="left"
          />
          <el-table-column
            label="用户编号"
            prop="user_no"
            width="130"
            align="center"
            fixed="left"
          />
          <el-table-column
            label="盘账日期"
            prop="date_desc"
            width="160"
            align="center"
          />

          <el-table-column
            label="期初金额"
            prop="init_amount"
            width="120"
            align="center"
          >
            <template #default="{ row }">
              <div class="cell-full" @click="openDetail(row, 'init_amount')">
                {{ row.init_amount }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="未开盒子"
            prop="wk_box_amount"
            width="120"
            align="center"
          >
            <template #default="{ row }">
              <div class="cell-full" @click="openDetail(row, 'wk_box_amount')">
                {{ row.wk_box_amount }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="充值金额"
            prop="recharge_amount"
            width="120"
            align="center"
          >
            <template #default="{ row }">
              <div
                class="cell-full"
                @click="openDetail(row, 'recharge_amount')"
              >
                {{ row.recharge_amount }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="赠送金额"
            prop="give_amount"
            width="120"
            align="center"
          >
            <template #default="{ row }">
              <div class="cell-full" @click="openDetail(row, 'give_amount')">
                {{ row.give_amount }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="提货金额"
            prop="take_amount"
            width="120"
            align="center"
          >
            <template #default="{ row }">
              <div class="cell-full" @click="openDetail(row, 'take_amount')">
                {{ row.take_amount }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="普通赏袋"
            prop="normal_prize_amount"
            width="120"
            align="center"
          >
            <template #default="{ row }">
              <div
                class="cell-full"
                @click="openDetail(row, 'normal_prize_amount')"
              >
                {{ row.normal_prize_amount }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="许愿金额"
            prop="wish_amount"
            width="120"
            align="center"
          >
            <template #default="{ row }">
              <div class="cell-full" @click="openDetail(row, 'wish_amount')">
                {{ row.wish_amount }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="卡册金额"
            prop="card_amount"
            width="120"
            align="center"
          >
            <template #default="{ row }">
              <div class="cell-full" @click="openDetail(row, 'card_amount')">
                {{ row.card_amount }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="保险箱"
            prop="lock_amount"
            width="120"
            align="center"
          >
            <template #default="{ row }">
              <div class="cell-full" @click="openDetail(row, 'lock_amount')">
                {{ row.lock_amount }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            label="金币"
            prop="balance"
            width="120"
            align="center"
          >
            <template #default="{ row }">
              <div class="cell-full" @click="openDetail(row, 'balance')">
                {{ row.balance }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="能量"
            prop="energy"
            width="120"
            align="center"
          >
            <template #default="{ row }">
              <div class="cell-full" @click="openDetail(row, 'energy')">
                {{ row.energy }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="钻石" prop="point" width="120" align="center">
            <template #default="{ row }">
              <div class="cell-full" @click="openDetail(row, 'point')">
                {{ row.point }}
              </div>
            </template>
          </el-table-column>
          <!-- 历史弹窗新增4个币种列 -->
          <el-table-column
            label="无限币"
            prop="blind_point"
            width="120"
            align="center"
          >
            <template #default="{ row }">
              <div class="cell-full" @click="openDetail(row, 'blind_point')">
                {{ row.blind_point }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="擂台币"
            prop="challenge_point"
            width="120"
            align="center"
          >
            <template #default="{ row }">
              <div class="cell-full" @click="openDetail(row, 'challenge_point')">
                {{ row.challenge_point }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="闯关币"
            prop="fight_point"
            width="120"
            align="center"
          >
            <template #default="{ row }">
              <div class="cell-full" @click="openDetail(row, 'fight_point')">
                {{ row.fight_point }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="PK币"
            prop="pk_point"
            width="120"
            align="center"
          >
            <template #default="{ row }">
              <div class="cell-full" @click="openDetail(row, 'pk_point')">
                {{ row.pk_point }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="亏损金额"
            prop="loss_amount"
            width="130"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <span
                :style="{
                  color: scope.row.loss_amount >= 0 ? '#f56c6c' : '#67c23a',
                  fontWeight: 600,
                }"
              >
                {{ scope.row.loss_amount }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <div v-else style="text-align: center; padding: 40px 0; color: #999">
          暂无历史亏损数据
        </div>
      </div>

      <!-- 移动端 历史卡片 -->
      <div class="mobile-history-wrapper" v-else>
        <div class="mobile-card-list" v-if="historyData.length > 0">
          <div
            class="mobile-card"
            v-for="item in historyData"
            :key="item.date_desc"
          >
            <div class="card-top">
              <div class="label">日期：{{ item.date_desc }}</div>
              <div
                class="loss"
                :style="{
                  color: item.loss_amount >= 0 ? '#f56c6c' : '#67c23a',
                }"
              >
                亏损：{{ item.loss_amount }}
              </div>
            </div>
            <!-- 历史卡片补充用户信息 -->
            <div class="card-user-info">
              <img
                v-if="item.avatar"
                :src="item.avatar"
                class="mobile-avatar"
              />
              <div class="user-text">
                <div>用户ID：{{ item.user_id }}</div>
                <div>编号：{{ item.user_no || "-" }}</div>
                <div>昵称：{{ item.nickname || "-" }}</div>
              </div>
            </div>
            <div class="card-body">
              <div><span>期初金额：</span>{{ item.init_amount }}</div>
              <div @click="openDetail(item, 'recharge_amount')">
                <span>充值金额：</span>{{ item.recharge_amount }}
              </div>
              <div @click="openDetail(item, 'give_amount')">
                <span>赠送金额：</span>{{ item.give_amount }}
              </div>
              <div @click="openDetail(item, 'take_amount')">
                <span>提货金额：</span>{{ item.take_amount }}
              </div>
              <div @click="openDetail(item, 'normal_prize_amount')">
                <span>普通赏袋：</span>{{ item.normal_prize_amount }}
              </div>
              <div @click="openDetail(item, 'wish_amount')">
                <span>许愿金额：</span>{{ item.wish_amount }}
              </div>
              <div @click="openDetail(item, 'card_amount')">
                <span>卡册金额：</span>{{ item.card_amount }}
              </div>
              <div @click="openDetail(item, 'lock_amount')">
                <span>保险箱：</span>{{ item.lock_amount }}
              </div>
              <div @click="openDetail(item, 'wk_box_amount')">
                <span>未开盒子：</span>{{ item.wk_box_amount }}
              </div>
              <div @click="openDetail(item, 'balance')">
                <span>金币：</span>{{ item.balance }}
              </div>
              <div @click="openDetail(item, 'energy')">
                <span>能量：</span>{{ item.energy }}
              </div>
              <div @click="openDetail(item, 'point')">
                <span>钻石：</span>{{ item.point }}
              </div>
              <!-- 历史移动端卡片新增4个币种 -->
              <div @click="openDetail(item, 'blind_point')">
                <span>无限币：</span>{{ item.blind_point }}
              </div>
              <div @click="openDetail(item, 'challenge_point')">
                <span>擂台币：</span>{{ item.challenge_point }}
              </div>
              <div @click="openDetail(item, 'fight_point')">
                <span>闯关币：</span>{{ item.fight_point }}
              </div>
              <div @click="openDetail(item, 'pk_point')">
                <span>PK币：</span>{{ item.pk_point }}
              </div>
            </div>
          </div>
        </div>
        <div v-else style="text-align: center; padding: 40px 0; color: #999">
          暂无历史亏损数据
        </div>
      </div>

      <div slot="footer" style="text-align: right">
        <el-button @click="historyVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "../../api/api.js";

export default {
  name: "UserLossLog",
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      searchParams: {
        page: 1,
        page_size: 10,
        user_id: "80861",
        start_at: "",
        end_at: "",
      },
      searchCollapsed: true,
      isPC: true,

      pcDetailVisible: false,
      mobileDetailVisible: false,
      detailLoading: false,
      showRow: {},
      showField: "",
      fieldText: "",
      detailContent: "",

      historyVisible: false,
      historyLoading: false,
      historyData: [],

      // ========== 新增列筛选配置 ==========
      columnOptions: [
        { label: "用户ID", prop: "user_id" },
        { label: "头像", prop: "avatar" },
        { label: "用户昵称", prop: "nickname" },
        { label: "用户编号", prop: "user_no" },
        { label: "盘账日期", prop: "date_desc" },
        { label: "期初金额", prop: "init_amount" },
        { label: "未开盒子", prop: "wk_box_amount" },
        { label: "充值金额", prop: "recharge_amount" },
        { label: "赠送金额", prop: "give_amount" },
        { label: "提货金额", prop: "take_amount" },
        { label: "普通赏袋", prop: "normal_prize_amount" },
        { label: "许愿金额", prop: "wish_amount" },
        { label: "卡册金额", prop: "card_amount" },
        { label: "保险箱", prop: "lock_amount" },
        { label: "金币", prop: "balance" },
        { label: "能量", prop: "energy" },
        { label: "钻石", prop: "point" },
        // 新增4个币种配置
        { label: "无限币", prop: "blind_point" },
        { label: "擂台币", prop: "challenge_point" },
        { label: "闯关币", prop: "fight_point" },
        { label: "PK币", prop: "pk_point" },
        { label: "亏损金额", prop: "loss_amount" },
      ],
      checkedColumns: [
        "user_id",
        "avatar",
        "nickname",
        "user_no",
        "date_desc",
        "init_amount",
        "wk_box_amount",
        "recharge_amount",
        "give_amount",
        "take_amount",
        "normal_prize_amount",
        "wish_amount",
        "card_amount",
        "lock_amount",
        "balance",
        "energy",
        "point",
        // 默认勾选新增字段
        "blind_point",
        "challenge_point",
        "fight_point",
        "pk_point",
        "loss_amount",
      ],
    };
  },
  created() {
    this.getList();
    this.checkDevice();
  },
  methods: {
    checkDevice() {
      this.isPC = !navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i);
    },
    async getList() {
      this.loading = true;
      try {
        const res = await api.loss.index({ params: this.searchParams });
        if (res.data.code == 1000) {
          this.tableData = res.data.data.data;
          this.total = res.data.data.total;
        }
      } finally {
        this.loading = false;
      }
    },

    async openDetail(row, field) {
      const fieldMap = {
        init_amount: "期初金额",
        recharge_amount: "充值金额",
        give_amount: "赠送金额",
        take_amount: "提货金额",
        normal_prize_amount: "普通赏袋",
        wish_amount: "许愿金额",
        card_amount: "卡册金额",
        lock_amount: "保险箱",
        wk_box_amount: "未开盒子",
        balance: "金币",
        energy: "能量",
        point: "钻石",
        // 新增映射
        blind_point: "无限币",
        challenge_point: "擂台币",
        fight_point: "闯关币",
        pk_point: "PK币",
      };

      this.showRow = { ...row };
      this.showField = field;
      this.fieldText = fieldMap[field] || field;
      this.detailLoading = true;
      this.detailContent = "";

      if (this.isPC) {
        this.pcDetailVisible = true;
      } else {
        this.mobileDetailVisible = true;
      }

      try {
        const res = await api.loss.detail({
          params: {
            user_id: row.user_id,
            loss_date: row.date_desc,
            loss_field: field,
          },
        });
        if (res.data.code == 1000) {
          this.detailContent = res.data.data;
        }
      } finally {
        this.detailLoading = false;
      }
    },
    // 全选列
    handleCheckAll() {
      this.checkedColumns = this.columnOptions.map((item) => item.prop);
    },
    // 清空列
    handleClearAll() {
      this.checkedColumns = [];
    },
    async openHistory() {
      if (!this.searchParams.user_id) {
        this.$message.warning("请先输入用户ID");
        return;
      }
      this.historyVisible = true;
      this.historyLoading = true;
      this.historyData = [];
      try {
        const res = await api.loss.dayLoss({
          params: {
            user_id: this.searchParams.user_id,
            start_at: this.searchParams.start_at,
            end_at: this.searchParams.end_at,
          },
        });
        if (res.data.code == 1000) {
          this.historyData = res.data.data;
        }
      } catch (error) {
        this.$message.error("获取历史数据失败");
      } finally {
        this.historyLoading = false;
      }
    },

    resetSearch() {
      this.searchParams = {
        page: 1,
        page_size: 10,
        user_id: "80861",
        start_at: "",
        end_at: "",
      };
      this.getList();
    },

    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },
    toggleSearch() {
      this.searchCollapsed = !this.searchCollapsed;
    },
  },
};
</script>

<style scoped>
.pc-version {
  display: block;
}
.mobile-version {
  display: none;
}

@media (max-width: 768px) {
  .pc-version {
    display: none;
  }
  .mobile-version {
    display: block;
  }
}

.loss-log-container {
  padding: 20px;
}
.table-wrapper {
  overflow: auto;
}
.cell-full {
  display: block;
  width: 100%;
  height: 100%;
  padding: 8px 0;
  cursor: pointer;
}
.cell-full:hover {
  background: #f0f2f5;
}

/* 表格头像样式 */
.table-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
}
.avatar-empty {
  color: #999;
  font-size: 12px;
}

.mobile-container {
  padding: 12px;
}
.mobile-search {
  background: #fff;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 10px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.card-top .label {
  font-size: 15px;
  font-weight: 500;
}
.card-top .loss {
  font-size: 15px;
  font-weight: 600;
}
/* 移动端卡片用户信息行 */
.card-user-info {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
}
.mobile-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
}
.user-text {
  font-size: 13px;
  color: #333;
  line-height: 1.6;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 2;
}
.card-body span {
  color: #999;
  display: inline-block;
  width: 100px;
}
.card-body div {
  padding: 2px 4px;
  border-radius: 4px;
}
.card-body div[click] {
  cursor: pointer;
}
.card-body div:hover {
  background: #f5f7fa;
}

.pc-detail-content {
  line-height: 2.2;
  font-size: 14px;
}
.pc-detail-content label {
  font-weight: bold;
  color: #333;
  width: 100px;
  display: inline-block;
}

.mobile-detail-content {
  line-height: 2.2;
  font-size: 14px;
}
.mobile-detail-content label {
  font-weight: bold;
  color: #333;
  width: 90px;
  display: inline-block;
}

.detail-list {
  padding: 12px;
  background: #f9f9f9;
  border-radius: 6px;
  min-height: 60px;
  white-space: pre-wrap;
  font-size: 13px;
}
/* 弹窗内头像 */
.detail-avatar {
  width: 50px;
  height: 50px;
  border-radius: 6px;
  vertical-align: middle;
  margin-left: 8px;
}

.history-table-wrapper {
  max-height: 60vh;
  overflow-y: auto;
}
.mobile-history-wrapper {
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 5px;
}
</style>


// WEBPACK FOOTER //
// src/pages/loss/index.vue